/*jshint esversion: 6 */

//import Fonts from "../assets/fonts/fonts.json";

//let Fonts = require("../assets/fonts/fonts.json");
let jCss = function(styleJSON){
	if(!styleJSON) return {};
	let computed = Object.keys(styleJSON).reduce((ns, prop)=>{
		let styleJSONItem = styleJSON[prop];
		if(prop === 'background'){
			if(styleJSONItem.type === 'transparent' ) {
				ns[prop] = 'transparent';
				return ns;
			}
			if(styleJSONItem.type === 'gradient'){
				ns[prop] = styleJSONItem.value.computed;
				return ns;
			}
			if(styleJSONItem.type === 'image'){
				let {position, size, src} = styleJSONItem.value;
				ns[prop] = `url(${src})`;
				if(position)ns.backgroundPosition = position;
				if(size)ns.backgroundSize = size;
				return ns;
			}
		}

		if(prop === 'boxShadow'){
			let generatedShadows = [];
			styleJSONItem.shadows.map((shadow)=>{
				let {i, x, y, r, o, color} = shadow;
				generatedShadows.push(`${i?'inset ':''}${x}px ${y}px ${r}px ${o}px ${color}`);
			});
			ns[prop] = generatedShadows.join(',');
			return ns;
		}

/*
		if(prop === 'fontFamily'){
			console.log(styleJSONItem)
			let foundFont = Fonts.find((font)=>{return font.id === styleJSONItem.id});
			console.log(foundFont)
			if(foundFont) {
				ns.fontFamily = `'${foundFont.name}', ${foundFont.family}`;
			}
			console.log(ns)
			return ns;
		}
*/


		if(styleJSONItem.unit){
			ns[prop] = styleJSONItem.value+styleJSONItem.unit; 
		} else {
			ns[prop] = styleJSONItem.value;
		}
		return ns;
	}, {});
	return computed;
};

let jCssStates = (styleJSON)=>{
	if(styleJSON&&styleJSON.normal){
		let {hover = {}, active = {}, normal} = styleJSON;
		normal = jCss(normal);
		hover = Object.assign({}, normal, jCss(hover));
		active = Object.assign({}, normal, hover, jCss(active));
		return {normal, hover, active};
	} else return jCss(styleJSON);
};

export default jCssStates;